import React from 'react'
import { connect } from 'react-redux';

import {
  getLoanSetupRate,
} from 'containers/LoanApplication/reducers';

class CurrentRate extends React.Component {
  render() {
    const {
      calculator,
    } = this.props

    if (calculator == undefined) {
      return(null)
    }

    return(
      <div className='card-footer bg-pale-green'>
        <div className='row'>
          <div className='col'>
            Current interest rate
          </div>
          <div className='col text-right'>
            <strong className='bigger'>{calculator.displayableRateLabel}</strong>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  calculator: getLoanSetupRate(state, ownProps.interestType)
})
export default connect(mapStateToProps)(CurrentRate);
